// frontend/src/lib/toast.ts
// Avisos no bloqueantes (reemplazan a alert()). Store mínimo a nivel de módulo
// para poder avisar desde cualquier lado (componentes, hooks, servicios); el
// <Toaster> (components/ui/Toaster.tsx) se suscribe y los dibuja.

export type TipoToast = 'success' | 'error' | 'info';

export interface Toast {
  id: number;
  tipo: TipoToast;
  mensaje: string;
  duracionMs: number;
}

const DURACION: Record<TipoToast, number> = { success: 3500, info: 4000, error: 5500 };
const MAX_VISIBLES = 3;

let toasts: Toast[] = [];
let siguienteId = 1;
const suscriptores = new Set<(t: Toast[]) => void>();
const timers = new Map<number, number>();

const emitir = () => {
  for (const fn of suscriptores) fn(toasts);
};

export function cerrarToast(id: number): void {
  const timer = timers.get(id);
  if (timer !== undefined) window.clearTimeout(timer);
  timers.delete(id);
  toasts = toasts.filter((t) => t.id !== id);
  emitir();
}

function mostrar(tipo: TipoToast, mensaje: string, opts?: { duracionMs?: number }): number {
  const id = siguienteId++;
  const nuevo: Toast = { id, tipo, mensaje, duracionMs: opts?.duracionMs ?? DURACION[tipo] };
  // El más nuevo arriba; si se pasan del máximo se descartan los más viejos
  const descartados = toasts.slice(MAX_VISIBLES - 1);
  for (const d of descartados) {
    const timer = timers.get(d.id);
    if (timer !== undefined) window.clearTimeout(timer);
    timers.delete(d.id);
  }
  toasts = [nuevo, ...toasts.slice(0, MAX_VISIBLES - 1)];
  timers.set(id, window.setTimeout(() => cerrarToast(id), nuevo.duracionMs));
  emitir();
  return id;
}

export const toast = {
  success: (mensaje: string, opts?: { duracionMs?: number }) => mostrar('success', mensaje, opts),
  error: (mensaje: string, opts?: { duracionMs?: number }) => mostrar('error', mensaje, opts),
  info: (mensaje: string, opts?: { duracionMs?: number }) => mostrar('info', mensaje, opts),
};

export function suscribirToasts(fn: (t: Toast[]) => void): () => void {
  suscriptores.add(fn);
  fn(toasts);
  return () => { suscriptores.delete(fn); };
}
